<template>
    <div>
        <h4 class="subtitle is-4">{{ $t("draw-settings.title") }}</h4>
        <div class="field">
            <label class="label">{{ $t("draw-settings.color") }}</label>
            <div class="control">
                <div class="buttons">
                    <template v-for="color in colors">
                        <button
                            class="button"
                            :class="{ 'is-active': isColorSelected(color) }"
                            :style="{ 'background-color': color.value }"
                            :key="color.key"
                            @click="selectColor(color)"
                        />
                    </template>
                </div>
            </div>
        </div>
        <div class="field">
            <label class="label">{{ $t("draw-settings.thickness") }}</label>
            <div class="control">
                <div class="buttons">
                    <template v-for="thickness in thicknesses">
                        <button
                            class="button"
                            :class="{
                                'is-active': isThicknesSelected(thickness),
                            }"
                            :key="thickness.key"
                            @click="selectThickness(thickness)"
                        >
                            {{ thickness.key }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "draw-settings",
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            settings: null,
            selectedColor: null,
            colors: [
                { key: "black", value: "black" },
                { key: "red", value: "red" },
                { key: "blue", value: "blue" },
                { key: "green", value: "green" },
                { key: "yellow", value: "yellow" },
                { key: "orange", value: "orange" },
            ],
            selectedThickness: null,
            thicknesses: [
                { key: 1, value: 1 },
                { key: 2, value: 2 },
                { key: 3, value: 3 },
                { key: 4, value: 5 },
                { key: 5, value: 5 },
                { key: 10, value: 10 },
            ],
        };
    },
    mounted() {
        this.settings = this.value;

        if (this.settings.color !== undefined) {
            this.selectedColor = this.colors.find(
                (c) => c.key === this.settings.color
            );
        }

        if (this.settings.thickness !== undefined) {
            this.selectedThickness = this.thicknesses.find(
                (t) => t.key === this.settings.thickness
            );
        }
    },
    methods: {
        selectColor(color) {
            this.selectedColor = color;
            this.settings.color = color.key;
            this.emitSettings();
        },
        isColorSelected(color) {
            return this.selectedColor === color;
        },
        selectThickness(thickness) {
            this.selectedThickness = thickness;
            this.settings.thickness = thickness.key;
            this.emitSettings();
        },
        isThicknesSelected(thickness) {
            return this.selectedThickness === thickness;
        },
        emitSettings() {
            this.$emit("input", this.settings);
        },
    },
};
</script>
